import { id } from "@stackflow/core";

export function makeStepId() {
  return id();
}
